"use client";

import Link from "next/link";
import { ScrollReveal } from "../scroll-reveal";
import { Button } from "../ui/button";
import { SubmitHandler, useForm } from "react-hook-form";
import { toast } from "sonner";
import { log } from "console";
import { useState } from "react";
import { LoaderCircle } from "lucide-react";

type Inputs = {
  name: string;
  phone: string;
  email: string;
  companyName: string;
  employeeCount: string;
};

export default function Cta() {
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<Inputs>();

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    const { name, phone, email, companyName, employeeCount } = data;
    setLoading(true);
    try {
      const res = await fetch("/api/send-mail", {
        method: "POST",
        body: JSON.stringify({
          name,
          phone,
          email,
          companyName,
          employeeCount,
        }),
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (res.ok) {
        toast.success("Gửi email thành công!");
      } else {
        toast.error("Có lỗi xảy ra khi gửi email!");
      }
      setLoading(false);
    } catch (error) {
      toast.error("Có lỗi xảy ra khi gửi email!");
      setLoading(false);
    }
  };

  return (
    <ScrollReveal direction="up" delay={0.3}>
      <div className="max-w-lg mx-auto">
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="bg-white p-6 rounded-2xl shadow-2xl"
        >
          <div className="grid md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className=" font-medium mb-1 block text-gray-700">
                Họ và tên
              </label>
              <input
                disabled={loading}
                type="text"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Nhập họ và tên"
                {...register("name", { required: true })}
              />
            </div>
            <div>
              <label className=" font-medium mb-1 block text-gray-700">
                Số điện thoại
              </label>
              <input
                disabled={loading}
                type="tel"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                placeholder="Nhập số điện thoại"
                {...register("phone", { required: true })}
              />
            </div>
          </div>
          <div className="mb-4">
            <label className=" font-medium mb-1 block text-gray-700">
              Email
            </label>
            <input
              disabled={loading}
              type="email"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Nhập địa chỉ email"
              {...register("email", { required: true })}
            />
          </div>
          <div className="mb-4">
            <label className=" font-medium mb-1 block text-gray-700">
              Tên doanh nghiệp
            </label>
            <input
              disabled={loading}
              type="text"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Nhập tên doanh nghiệp"
              {...register("companyName", { required: true })}
            />
          </div>
          <div className="mb-4">
            <label className=" font-medium mb-1 block text-gray-700">
              Số lượng nhân viên
            </label>
            <select
              disabled={loading}
              {...register("employeeCount")}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
            >
              <option value="">Chọn số lượng</option>
              <option value="1-5">1-5 nhân viên</option>
              <option value="6-10">6-10 nhân viên</option>
              <option value="11-20">11-20 nhân viên</option>
              <option value=">20">Trên 20 nhân viên</option>
            </select>
          </div>
          <Button
            className="w-full bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white text-lg py-3"
            disabled={loading}
          >
            {loading && <LoaderCircle className="animate-spin" />}
            Bắt đầu dùng thử miễn phí
          </Button>
          <p className=" text-center text-muted-foreground mt-4">
            Bằng cách đăng ký, bạn đồng ý với
            <Link href="#" className="text-indigo-500 hover:underline">
              {" "}
              Điều khoản dịch vụ{" "}
            </Link>
            và
            <Link href="#" className="text-indigo-500 hover:underline">
              {" "}
              Chính sách bảo mật
            </Link>{" "}
            của chúng tôi.
          </p>
        </form>
      </div>
    </ScrollReveal>
  );
}
